export class Punto {
  latitud: number;
  longitud: number;

  constructor(latitud:number, longitud:number){
    this.longitud = longitud;
    this.latitud = latitud;
  }
}
